import Component from '../abstracts/Component';

export default class ProductZoomComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-image-zoom="true"]',
      layer: '.js-product-gallery-zoom',
      header: 'header',
      close: '.js-close',
      body: 'body',
      zoomDt: '.js-product-zoom-md'
    }
  }

  get CLASSES() {
    return {
      visible: 'is-visible',
      active: 'is-active',
      pdpZoom: 'pdp-zoom',
      opened: 'search-opened'
    }
  }

  constructor() {
    super()
  }

  onOpenZoom() {
    let mainImage = $('.easyzoom-flyout').find("img");
    mainImage.unbind("click");
    mainImage.on('click', function() {
      $(".js-product-gallery-zoom .js-close").click();
    });

    $('.easyzoom-flyout').fadeIn("slow");
  }

  bindCustomEvents() {
    let ctx = this;
    let body = $(this.SELECTORS.body);

    body.on('click.zoom', this.SELECTORS.main, function(e) {
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.ZOOM_EVENTS.open, {
        img: $this,
        wrapper: ctx.SELECTORS.layer
      });
    });

    this.$on(this.$customEvents.ZOOM_EVENTS.open, ({event, payload}) => {
      if ($(this.SELECTORS.header).hasClass(this.CLASSES.opened)) {
        $(this.SELECTORS.header).css('z-index', -9999);
      }
      if (!ctx.$matchMedia('sm', null)) {
         ctx.buildEasy(payload.img, payload.wrapper);
      } else {
        ctx.buildDrag(payload.img, payload.wrapper);
      }
      body.addClass(ctx.CLASSES.pdpZoom);
    });
  }

  buildDrag(element, wrapper,) {
    let ctx = this
    let src = $(element).data('imageZoomSrc');
    let carousel =  $(this.SELECTORS.layer).find('.carousel');

    this.log(src);
    document.body.classList.add(this.CLASSES.pdpZoom);
    $(this.SELECTORS.layer).addClass(this.CLASSES.visible);
    if (carousel.hasClass('slick-initialized')) carousel.slick('unslick');
    carousel.slick({
      arrows: true,
      initialSlide: $(element).data('index')-1,
      // swipe: false,
      lazyLoad: 'ondemand'
    })

    $(this.SELECTORS.close).on('click', function() {
      $(ctx.SELECTORS.layer).removeClass(ctx.CLASSES.visible);
      document.body.classList.remove(ctx.CLASSES.pdpZoom);
      $(ctx.SELECTORS.header).css('z-index', 6);
    })
  }

  buildEasy(element, wrapper, clickevent) {
    let
      ctx = this,
      $el = $(element),
      $ref = $el.find('figure').data('itemZoom'),
      $wrapper = $(wrapper),
      $zoom = $wrapper.find('.zoom'),
      $zoomImg = $zoom.find('a'),
      $thumbs = $wrapper.find('.thumbnails'),
      $thumb = $thumbs.find('li a').first(),
      $close = $wrapper.find('.js-close');

    let indexImageZoomOnStart = $el.data('indexZoom');
    // set the src
    $zoomImg.attr('href', $el.data('image-zoom-src'));

    $close.on('click', function() {
      // reset easyzoom
      let zoomDiv = $wrapper.find('.easyzoom-flyout');
      // hide wrapper
      zoomDiv.fadeOut();
      $wrapper.fadeOut();
      // remove class from body
      $(ctx.SELECTORS.body).removeClass(ctx.CLASSES.pdpZoom);
      zoomDiv.remove();
      $(ctx.SELECTORS.header).css('z-index', 6);
    });

    if (!ctx.$matchMedia('md', null)) {

      import( /*webpackChunkName: `easyzoom` */ "easyzoom").then((module) =>{

        // update default zoom image
        $zoom.easyZoom({
          loadingNotice: "",
          onShow: function() {
            ctx.onOpenZoom();
          }
        });

        let api = $zoom.data('easyZoom');
        api.resetCanvas = api.hide;
        api.hide = $.noop;
        $thumbs.off('click', 'a').on('click', 'a', function(e) {
          let $self = $(this);
          e.preventDefault();
          $thumbs.find('li a').removeClass(ctx.CLASSES.active);
          $self.addClass(ctx.CLASSES.active);

          $('.easyzoom-flyout').fadeOut(function() {
            api.resetCanvas();
            api.swap($self.data('standard'), $self.attr('href'));
            api.show();
            $wrapper.fadeIn();
          });

          setTimeout(() => {
            api.show();
            $wrapper.fadeIn();
          }, 0);
        });

        if(indexImageZoomOnStart>0){
          $thumbs.find('[data-index-zoom='+ indexImageZoomOnStart +']').trigger('click');
        } else {
          $thumb.trigger('click');
        }

      }).catch(error => {
        console.error("Failed to load the component", error);
      });
    } else {
      let image = document.createElement('img');
      let src = $(ctx.SELECTORS.zoomDt).find('a').attr('href');

      image.src = src;
      $(ctx.SELECTORS.zoomDt).append(image);

      $thumbs.on('click', 'a', function(e) {
        e.preventDefault();
        let $self = $(this);
        let src =   $self.attr('href');
        $(ctx.SELECTORS.zoomDt).find('img').attr('src', src);
      });

    }
    // update default zoom image
  }

  render() {
    super.render();
    this.bindCustomEvents();

    var scrolled = false;

    $(window).scroll( function(){
      if (! scrolled) {
        $('.js__discover-look').addClass('show');
        scrolled = true;
      }
    })

    $('.suggestions__input').on('mouseover', function(){
      $('.js__discover-look').addClass('show');
    })
  }
}
